import { render, staticRenderFns } from "./SipaeeProfileAddStudent.vue?vue&type=template&id=756627c8&scoped=true"
import script from "./SipaeeProfileAddStudent.vue?vue&type=script&lang=js"
export * from "./SipaeeProfileAddStudent.vue?vue&type=script&lang=js"
import style0 from "./SipaeeProfileAddStudent.vue?vue&type=style&index=0&id=756627c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756627c8",
  null
  
)

export default component.exports